import React from "react";
import { Card, Icon } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { useAuth } from "context/AuthContext"; // Importe o hook de autenticação

import gif from "assets/images/cardimgfree.png";

const WelcomeMark = () => {
  const { user } = useAuth(); // Obtenha o usuário do contexto

  // Extraia o primeiro nome do usuário, com um fallback
  const getFirstName = () => {
    if (user && user.user_metadata && user.user_metadata.full_name) {
      return user.user_metadata.full_name.split(' ')[0];
    }
    return "User"; // Fallback caso o nome não esteja disponível
  };

  return (
    <Card sx={() => ({
      height: "340px",
      py: "32px",
      backgroundImage: `url(${gif})`,
      backgroundSize: "cover",
      backgroundPosition: "50%"
    })}>
      <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
        <VuiBox>
          <VuiTypography color="text" variant="button" fontWeight="regular" mb="12px">
            Bem vindo novamente,
          </VuiTypography>
          <VuiTypography color="white" variant="h3" fontWeight="bold" mb="18px">
            {getFirstName()}
          </VuiTypography>
          <VuiTypography color="text" variant="h6" fontWeight="regular" mb="auto">
            Que bom ver você de novo!
            <br /> Pergunte-me o que quiser.
          </VuiTypography>
        </VuiBox>
        <VuiTypography
          component="a"
          href="https://wa.me/5511989205971?text=Oi%20Roberto!%20Preciso%20de%20ajuda%20com%20o%20SaferDock."
          target="_blank"
          rel="noopener noreferrer"
          variant="button"
          color="white"
          fontWeight="regular"
          sx={{
            mr: "5px",
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",

            "& .material-icons-round": {
              fontSize: "1.125rem",
              transform: `translate(2px, -0.5px)`,
              transition: "transform 0.2s cubic-bezier(0.34,1.61,0.7,1.3)",
            },

            "&:hover .material-icons-round, &:focus  .material-icons-round": {
              transform: `translate(6px, -0.5px)`,
            },
          }}
        >
          Aperte para perguntar
          <Icon sx={{ fontWeight: "bold", ml: "5px" }}>arrow_forward</Icon>
        </VuiTypography>
      </VuiBox>
    </Card>
  );
};

export default WelcomeMark;
